import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { StoreState, useBasketSecretGetEffect } from '../../../state';

export function useBasketSecretEffect() {
  const { basketDataState } = useSelector((state: StoreState) => ({
    basketDataState: state.data.basket,
  }));

  const basketSecretGet = useBasketSecretGetEffect();

  useEffect(() => {
    const { secret, cart } = basketDataState;
    const { loading, success, error } = basketSecretGet;

    if (!loading && !success && !error && !secret && cart) {
      basketSecretGet.enact(cart.id);
    }
  }, [basketDataState, basketSecretGet]);
}
